import { IUnsavedChangesDialogState } from "./store";

export const handleClose = (store: IUnsavedChangesDialogState) => {
    store.setShowUnsavedChangesPrompt(false);

}


export const handleContinue = (store: IUnsavedChangesDialogState, onContinue?: () => void) => {
    store.setShowUnsavedChangesPrompt(false);
    if (onContinue) {
        onContinue();
    }
}
